import request from '@/untils/request'
export default {
  // 查询单个票样的信息
  ticketfindById(data) {
    return request({
      method: "post",
      url: "/ticket/infoList/findById",
      params: {
          "id": data
      }
    });
  },

   // 提交订单
   createOrder(data) {
    return request({
      method: "post",
      url: "/ticket/order/createOrder",
      params: {
          "bookdate": data.bookdate,
          "ordertotal": data.ordertotal,
          "tickettype": data.tickettype,
          "sellerSystem": 20,   // 来源，官网：20，小程序：60（默认60）
      }
    });
  },

  // 手机验证码
  getPhone(data) {
    return request({
      url: "/ticket/order/getSMSByPhone",
      methods: "post",
      params: {
        "phone": data.phone,
        "verifycode": data.verifycode
      }
    })   
  },

  // 判断验证码是否正确
  checkCode(data) {
    return request({
      url: "/ticket/order/checkCode",
      methods: "post",
      params: {
        "phone": data.phone,
        "code": data.code

      }
    })   
  },

  // 购票须知
  loadNoticeList(data) {
    return request({
       url: "/ticket/ticketinstructions/loadAdmissionNoticeList",
       method: "post",
       params: data    
    });
  },

    // 查询个人信息
    ticketAppUser(params) {
        return request({
          url: "/ticketAppUser/profile",
          methods: "post",
          params
        }) 
    },

    // // 动态获取md5加密的值
    // getUseKey(params) {
    //     return request({
    //       url: "/ticket/order/getUseKey",
    //       methods: "post",
    //       params
    //     }) 
    // },

    // // 验证身份证是否正确
    // idCodesss(idCode) {
    //     return request({
    //       url: "/id18",
    //       methods: "post",
    //       params: {
    //         "idCode": idCode
    //       }
    //     }) 
    // },
 
};



// WEBPACK FOOTER //
// ./src/api/authentication.js